import { Amplify } from 'aws-amplify';
import 'aws-amplify/auth/enable-oauth-listener';

/** Written by the CDK deployment next to index.html, so one build works for every stage. */
export interface RuntimeConfig {
  stage: string;
  region: string;
  userPoolId: string;
  userPoolClientId: string;
  cognitoDomain: string;
}

/**
 * The URL the app was loaded with. Captured before Amplify handles an OAuth callback (which rewrites
 * the URL) so the callback page can still read any error Cognito sent back.
 */
export const initialUrl = new URL(window.location.href);

export async function loadConfig(): Promise<RuntimeConfig> {
  const res = await fetch('/config.json', { cache: 'no-store' });
  if (!res.ok) throw new Error(`Could not load /config.json (${res.status})`);
  const config = (await res.json()) as RuntimeConfig;

  const origin = window.location.origin;
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: config.userPoolId,
        userPoolClientId: config.userPoolClientId,
        loginWith: {
          oauth: {
            domain: config.cognitoDomain,
            scopes: ['openid', 'profile'],
            redirectSignIn: [`${origin}/auth/callback`],
            redirectSignOut: [`${origin}/`],
            responseType: 'code',
            providers: [{ custom: 'Discord' }],
          },
        },
      },
    },
  });
  return config;
}
